module.exports = __webpack_public_path__ + "img/tab-1.31c73ed.svg";